import { FC, SVGProps } from 'react'

interface SubscribeCardIconGemProps extends SVGProps<SVGSVGElement> {
  size?: number
}

export const SubscribeCardIconGem: FC<SubscribeCardIconGemProps> = ({
  size = 24,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -2 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.02253 4.91427L9.12089 2.02778C10.8476 0.811609 13.1524 0.811609 14.8791 2.02778L18.9775 4.91428C19.7753 5.47621 20.25 6.39111 20.25 7.367V16.8459C20.25 17.8438 19.7538 18.7764 18.9262 19.3339L14.7936 22.118C13.1049 23.2556 10.8951 23.2556 9.20639 22.118L5.07383 19.334C4.24621 18.7764 3.75 17.8438 3.75 16.8459V7.367C3.75 6.39111 4.22467 5.47621 5.02253 4.91427Z"
        stroke="white"
        strokeOpacity="0.7"
      />
      <path
        d="M8.04334 7.23694L9.72445 6.07407C11.0937 5.12695 12.9063 5.12695 14.2756 6.07407L15.9567 7.23694C16.7666 7.79721 17.25 8.71934 17.25 9.70419V14.414C17.25 15.4208 16.745 16.3604 15.9054 16.916L14.2072 18.0396C12.8689 18.9251 11.1311 18.9251 9.79279 18.0396L8.09459 16.916C7.25498 16.3604 6.75 15.4208 6.75 14.414V9.70419C6.75 8.71934 7.23338 7.79721 8.04334 7.23694Z"
        stroke="white"
        strokeOpacity="0.7"
      />
      <circle cx="10.125" cy="10.125" r="1.125" fill="#D9D9D9" />
    </svg>
  )
}
